import { Injectable, signal } from '@angular/core';

export interface OmniSearchOption {
  title: string;
  description: string;
  shortcut: string;
  callback: () => void;
}

@Injectable()
export class OmniSearchService {
  private _options = signal<OmniSearchOption[]>([]);
  options = this._options.asReadonly();

  registerOptions(options: OmniSearchOption[]): void {
    this._options.set(options);
  }
}
